/**
 * Campos de exibição no site (banner promocional) de uma campanha.
 * Persistidos no Firestore (shopSettings) — espelhados para `MGM_PROMO_ACTION`
 * quando a campanha está ativa. Mantém o mesmo shape lido pelo storefront da Glam.
 */
export interface CampaignDisplay {
  active: boolean;
  actionId: string;
  title: string;
  description: string;
  desktopImage: string | null;
  mobileImage: string | null;
  validFrom: string | null;
  validTo: string | null;
  rulesModal: {
    title: string;
    paragraphs: string[];
  };
  /** Campanha dona do espelho atual — usado para rastreio/desativação. */
  campaignId?: number;
}
